<script>
import contact from "@/utils/contact";
import LoaderMixin from "@/mixins/Loader.mixin";
import CarbonTargetModel from "@/models/CarbonTargetModel";
import ModelMixin from "@/mixins/Model.mixin";
import { mapGetters } from 'vuex';
import { unique } from "@/utils/"

const TARGET = CarbonTargetModel.ModelName

export default {
  mixins: [
    LoaderMixin([TARGET]),
    ModelMixin({
      contact,
      models: [CarbonTargetModel]
    })
  ],
  model:{
    prop: "value",
    event: "change"
  },
  props: {
    params: {
      type: Object,
      default: ()=>{}
    },
    disabled: {
      type: Boolean
    },
    transfer: Boolean,
    canNew: Boolean,
    disable: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    hasPagination: {
      type: Boolean,
      default: true
    },
    remote: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    itemCreateFun: {
      type: Function,
      default: ()=>Promise.resolve(true)
    },
    options: {
      type: Array,
      default: ()=>[]
    },
    value: {
      type: Array,
      default: ()=>[]
    },
    placeholder: {
      type: String,
      default: "三级指标"
    },
  },
  watch:{
    value(val){
      this.sources.value = val
    },
    params(val){
      this.conditions = val
    }
  },
  render(h){
    const {
      $attrs,
      $props,
    } = this
    return h('RichSearchInput',{
      attrs: $attrs,
      props: {
        ...$props,
        remote: true,
        options: this.items,
        remoteOptions: this.remoteOptions,
        remoteValue: this.remoteValue,
      },
      on: {
        change: this.onChanged,
      },
    },[])
  },
  data(){
    return {
      loading: false,
      input: '',
      pagination: { page:1, total:0, limit:1000, offset:0 },
      items: [],
      sources: {
        value: []
      },
      conditions: {},
      thirdTarget:[]
    }
  },
  methods: {
    async refreshthirdTarget(query) {
      this.list = await this.$$active(TARGET, 'thirdTarget',query)
      this.list.data = this.list.data.map(item => ({
          ...item,
          id: item.thirdTargetNum,
          name: item.thirdTargetName,
          title: item.thirdTargetName,
        }));
    },
    async remoteOptions({ currentPage, limit=1000, searchTxt }) {
      this.$$loading(TARGET);
      const offset = !!searchTxt ? 0 : currentPage * limit - limit
      await this.refreshthirdTarget({
          limit: limit,
          offset: offset, 
          thirdTargetName: searchTxt
      });
      return {
        items: this.list.data,
        total: this.list.total,
        currentPage: currentPage,
      }
      this.$$loaded(TARGET);
    },
    async remoteValue({items,checkIds}){
      if(checkIds.length === 0) return Promise.resolve([]);
      const [ thirdTargetNum ] = checkIds
      await this.refreshthirdTarget({ limit: 10, offset: 0 , thirdTargetList: JSON.stringify(checkIds)})
      return Promise.resolve(this.list.data)
    },
    onChanged(value){
      this.$emit("change", value)
    },
  },
}
</script>
